<!DOCTYPE html>

<head>
  <meta name="viewport" content="width=device-width, initial-scale=1">
</head>
<ng-container *ngIf="user">
  <app-toolbar [user]="user" [title]="title" [back]="true" [destination]=""></app-toolbar>
</ng-container>
<h2 style="text-align: center; padding-top: 20px; padding-bottom: 20px">Raccolte dati</h2>
<!--
<mat-expansion-panel [expanded] = "false"
                     (opened)="panelOpenStateUC = true"
                     (closed)="panelOpenStateUC = false">
  <mat-expansion-panel-header [collapsedHeight]="'190px'" [expandedHeight]="'100px'">
    <mat-panel-title>
      Raccolta dati - Rettocolite ulcerosa
    </mat-panel-title>
    <mat-panel-description>
      Dati PATIENT-SCCAI, CLINICAL-SCCAI, PRISM, CLINICAL-PRISM
    </mat-panel-description>
  </mat-expansion-panel-header>
  <app-uc-data *ngIf="panelOpenStateUC"></app-uc-data>
</mat-expansion-panel>

<mat-expansion-panel [expanded] = "false"
                     (opened)="panelOpenStateCrohn = true"
                     (closed)="panelOpenStateCrohn = false">
  <mat-expansion-panel-header [collapsedHeight]="'190px'" [expandedHeight]="'100px'">
    <mat-panel-title>
      Raccolta dati - Malattia di Crohn
    </mat-panel-title>
    <mat-panel-description>
      Dati PATIENT-HBI, CLINICAL-HBI, PRISM, CLINICAL-PRISM
    </mat-panel-description>
  </mat-expansion-panel-header>
  <app-cd-data *ngIf="panelOpenStateCrohn"></app-cd-data>
</mat-expansion-panel>
-->

<h3 style="text-align: center; padding-top: 20px; padding-bottom: 20px">Dati Concordanza</h3>

<div class="container && mat-elevation-z5">
  <app-cd-uc-data *ngIf="panelOpenStateCrohn"></app-cd-uc-data>
</div>

<div style="text-align: center; padding-top: 20px;"></div>
<h3 style="text-align: center; padding-top: 20px; padding-bottom: 20px">Dati Questionari + Gradimento</h3>

<div class="container && mat-elevation-z5" style="text-align: center; padding-top: 20px;">
  <app-analyses-data *ngIf="panelOpenStateCrohn"></app-analyses-data>
</div>